<script setup lang="ts">
    import { defineProps } from 'vue';
    interface Props {
        ejecutivo?: boolean,
        virtual?: boolean,
    }

    defineProps<Props>();
</script>

<template>
    <section class="flex flex-col justify-center items-center mt-8 px-4">
        <h2 class="font-serif text-hgold text-3xl">Planes de estudio</h2>
        <p class="font-helvetica text-[18px] text-base leading-6">
            <span v-if="ejecutivo">EJECUTIVO</span>
            <span v-if="(ejecutivo && virtual)">&nbsp;•&nbsp;</span>
            <span v-if="virtual">VIRTUAL</span>
        </p>
        <hr class="my-2 flex items-center justify-center border-gray-400 w-[18%]">
        <div class="flex flex-col items-center justify-center">
            <p>4 ciclos modulares semestrales (2 años)</p>
            <p>•&nbsp;&nbsp;22 semanas de clase</p>
        </div>
        <p>•&nbsp;&nbsp;1&nbsp;&nbsp;semana de evaluaci&oacute;n final</p>
        <br>
    </section>
</template>

<style lang="scss" scoped>
</style>